import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SetDirectoryData } from '../../../model/directory-data.model';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatButton, MatIconButton } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-set-directory',
  templateUrl: './set-directory.component.html',
  imports: [MatIcon, MatDivider, MatIconButton, MatButton, TitleCasePipe]
})
export class SetDirectoryComponent {
  @Input() data: SetDirectoryData;
  @Output() setDirectory: EventEmitter<string> = new EventEmitter();
  @Output() deleteDirectory: EventEmitter<string> = new EventEmitter();
}
